import { getBackendUrl } from "../config";

const isBlankPicture = (value) => {
  if (value === null || value === undefined) return true;

  const normalized = String(value).trim();
  return (
    normalized === "" ||
    normalized === "null" ||
    normalized === "undefined"
  );
};

const normalizePictureUrl = (value, companyId) => {
  if (isBlankPicture(value)) return "";

  const picture = String(value).trim();
  const backendUrl = getBackendUrl();

  const publicPathIndex = picture.indexOf("/public/");
  if (publicPathIndex > -1) {
    try {
      return new URL(picture).href;
    } catch {
      return `${backendUrl}${picture.substring(publicPathIndex)}`;
    }
  }

  if (
    picture.startsWith("http://") ||
    picture.startsWith("https://") ||
    picture.startsWith("data:")
  ) {
    return picture;
  }

  if (picture.startsWith("/public/")) {
    return `${backendUrl}${picture}`;
  }

  if (picture.startsWith("public/")) {
    return `${backendUrl}/${picture}`;
  }

  if (picture === "nopicture.png") {
    return `${backendUrl}/nopicture.png`;
  }

  if (!companyId) return picture;

  return `${backendUrl}/public/company${companyId}/contacts/${picture}`;
};

const getContactPictureUrl = (contact) => {
  if (!contact) return "";

  return (
    normalizePictureUrl(contact.urlPicture, contact.companyId) ||
    normalizePictureUrl(contact.profilePicUrl, contact.companyId)
  );
};

export default getContactPictureUrl;
